











import { Component, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';

@Component({
  components: {
    Button,
  },
})
export default class StatementBtn extends Vue {
  clickHandler(value: string) {
    this.$emit('btnClick', value);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/statementbtn/StatementBtn.vue